exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swal2-popup button.swal2-confirm.swal2-styled{background-color:#fedc01;border-color:#fedc01;color:#000}", ""]);

// exports
